import * as types from '../actions/actionTypes'

export const initialState = {
  paymentInfo: null,
  isIdentical: false, // * seller = buyer
  isBlockedByAIFIExclusive: false,
}

export function isMemberInfoFetchedSelector(buyer) {
  const { paymentInfo } = buyer
  return paymentInfo && typeof paymentInfo.token_discount === 'number'
}

export default function buyerReducer(buyer = initialState, action) {
  switch (action.type) {
    case types.GET_PAYMENT_INFO_GUEST_SUCCESS:
    case types.GET_PAYMENT_INFO_MEMBER_SUCCESS:
      return {
        ...buyer,
        paymentInfo: action.payload,
      }
    case types.GET_PAYMENT_INFO_MEMBER_ERROR_IDENTICAL:
      return {
        ...buyer,
        isIdentical: true,
      }
    case types.GET_PAYMENT_INFO_MEMBER_ERROR_AIFI_OWNER_EXCLUSIVE:
      return {
        ...buyer,
        isBlockedByAIFIExclusive: true,
      }
    case types.LOGOUT_SUCCESS:
    case types.LOGOUT_ERROR:
      return {
        ...buyer,
        isIdentical: false,
      }
    default:
      return buyer
  }
}

/*
paymentInfo: {
  "title": "團購名稱",
  "contact": "+886912345678",
  "price": 2000,    // 商品單價 (NTD)
  "instalment": 6,  // 分期期數
  "max_qty": 2,     // 可購買之數量上限
  "payment_amount": 335,  // 不分期/首期應付金額 (台幣)
  "exchange_rate": 31,    // 台幣兌美元匯率
  "status": "created",     // created (開放中); terminated (已停止收款); filled (已額滿); expired (已結束)
  -- members only:
  "cash_discount": 120,     // "Slash收款"折抵金額 (Slash收款+Slash回饋=Slash折抵金額)
  "reward_discount": 160,   // "Slash回饋"折抵金額 (Slash收款+Slash回饋=Slash折抵金額)
  "token_discount": 35,     // "我的回饋"折抵金額
  "deposit_amount": 20,     // 不分期/首期實付金額 (台幣)
  "disposable_amount": 280, // 可動用的Slash餘額
  "disposable_tokens": 35,  // 現有的回饋餘額
	"disposable_product_cash": 120,   // 可動用之 Slash 現金收款金額
	"disposable_product_reward": 160, // 可動用之 Slash 回饋收款金額
}
 */
